import "vant/es/loading/style";
import _Loading from "vant/es/loading";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/componentImg/liked_icon.png';
import _imports_1 from '@/assets/componentImg/like_icon.png';
import _imports_2 from '@/assets/componentImg/arrow.png';

const _withScopeId = n => (_pushScopeId("data-v-003405be"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "user-wrap"
};
const _hoisted_2 = {
  class: "name-wrap"
};
const _hoisted_3 = {
  class: "name"
};
const _hoisted_4 = {
  key: 0,
  class: "topFlag"
};
const _hoisted_5 = {
  src: _imports_0,
  alt: ""
};
const _hoisted_6 = {
  src: _imports_1,
  alt: ""
};
const _hoisted_7 = {
  class: "content-wrap"
};
const _hoisted_8 = {
  class: "text-wrap"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "date-wrap"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));

const _hoisted_13 = /*#__PURE__*/_createTextVNode("回复加载中...");

import composition from '@/composition';
import { computed } from 'vue';
const __default__ = {
  name: 'comment-cell'
};
export default /*#__PURE__*/Object.assign(__default__, {
  props: {
    item: Object,
    isLast: Boolean
  },

  setup(__props) {
    const props = __props;
    const {
      ref,
      openApp,
      formatTime,
      CImage,
      request,
      throttle,
      loginHandle,
      store
    } = composition();
    const data = ref(props.item); // 点赞

    const like = throttle(() => {
      loginHandle().then(() => {
        _Toast.loading({
          message: '点赞中...',
          duration: 0,
          forbidClick: true
        });

        const state = data.value.loveState == false ? 1 : 0;
        request.likeComment(data.value.id, state, data.value.postId).then(res => {
          data.value.loveState = state == 1 ? true : false;
          state == 1 ? data.value.loveCount++ : data.value.loveCount--;

          _Toast.success(res.msg);
        }).catch(error => {
          _Toast.fail(error.message);
        });
      }).catch(() => {});
    });
    const commentCount = computed(() => {
      const count = data.value.commentCount - data.value.childComments.length;
      return count > 0 ? count : 0;
    });
    const orderType = computed(() => {
      return store.state.commentOrder;
    }); // 展开更多评论

    const subReplyState = ref(-1); // 子回复列表状态 0 loading 1 success

    const expandMoreComment = item => {
      subReplyState.value = 0;
      setTimeout(() => {
        request.getPostComments({
          postId: item.postId,
          parentId: item.id,
          page: 1,
          pageSize: item.commentCount,
          order: store.state.commentOrder
        }).then(res => {
          subReplyState.value = 1;
          data.value.childComments = res.data;
          data.value.commentCount = res.data.length;
        }).catch(() => {
          subReplyState.value = -1;

          _Toast.fail('加载失败');
        });
      }, 500);
    };

    return (_ctx, _cache) => {
      const _component_comment_cell = _resolveComponent("comment-cell", true);

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['comment-cell', __props.isLast ? 'last-comment-cell' : ''])
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(CImage), {
        class: "head-pic",
        src: __props.item.memberPhoto
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(__props.item.memberNickname), 1), _unref(orderType) == 'hotCount' & __props.item.sno == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_4, "置顶")) : _createCommentVNode("", true)]), _createElementVNode("div", {
        class: _normalizeClass(['like-btn', data.value.loveState == true ? 'liked-btn' : '']),
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(like) && _unref(like)(...args))
      }, [_createTextVNode(_toDisplayString(data.value.loveCount) + " ", 1), _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [[_vShow, data.value.loveState == true]]), _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [[_vShow, data.value.loveState != true]])], 2)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", _hoisted_8, [__props.item.toMemberNickname ? (_openBlock(), _createElementBlock("span", _hoisted_9, "回复@" + _toDisplayString(__props.item.toMemberNickname) + "：", 1)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(__props.item.content), 1)]), __props.item.imgPath.length > 0 ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "comment-img",
        onClick: _cache[1] || (_cache[1] = $event => _unref(openApp)()),
        src: __props.item.imgPath
      }, null, 8, _hoisted_10)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_createTextVNode(_toDisplayString(_unref(formatTime)(__props.item.createTime)) + " ", 1), _createElementVNode("span", null, "来自" + _toDisplayString(__props.item.ipAddress), 1)]), _createElementVNode("span", {
        onClick: _cache[2] || (_cache[2] = $event => _unref(openApp)())
      }, "回复")]), data.value.childComments.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(data.value.childComments, (comment, index) => {
        return _openBlock(), _createBlock(_component_comment_cell, {
          key: comment.parentId + '_' + comment.id,
          isLast: index == __props.item.childComments.length - 1,
          item: comment
        }, null, 8, ["isLast", "item"]);
      }), 128)) : _createCommentVNode("", true), _unref(commentCount) > 0 && subReplyState.value == -1 && data.value.childComments >= 20 ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "more-btn",
        onClick: _cache[3] || (_cache[3] = $event => expandMoreComment(__props.item))
      }, [_createTextVNode(" 展开" + _toDisplayString(_unref(commentCount)) + "条回复 ", 1), _hoisted_12])) : _createCommentVNode("", true), subReplyState.value == 0 ? (_openBlock(), _createBlock(_unref(_Loading), {
        key: 3,
        class: "loading",
        size: "12px"
      }, {
        default: _withCtx(() => [_hoisted_13]),
        _: 1
      })) : _createCommentVNode("", true)])], 2);
    };
  }

});